import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { Container } from '../Container';
import { HOCPanel } from '../Panel/Panel';

import './Authentication.scss';
import { AuthenticationContent } from './AuthenticationContent';
import { BiometricSignIn } from './BiometricSignIn';

interface AuthMainProps {
  agreeCompetitionValue: boolean;
  allFilled: boolean;
  banner?: string;
  competitionExists: any;
  competitionId: string;
  competitionName: string;
  email: string;
  errors: { email: string; currentPassword: string };
  handleBiometricCancel: () => void;
  handleBiometricSignIn: (inquiryId: string) => void;
  handleBlur: (dataInfo: any) => void;
  handleChange: (event: any, data: any) => void;
  handleCleanCaptcha: () => void;
  handlePasswordKeyUp: (event: any) => void;
  handleResetSelfieError: () => void;
  handleSignUp: () => void;
  handleUserLogin: (event: any) => void;
  hasLoggedInBefore: boolean;
  inquiryId?: string;
  isCapsLockOn: boolean;
  isSelfieError: boolean;
  isLoading: boolean;
  isLoggedIn: boolean;
  password: string;
  previousLocation: any;
}

type AuthMainPropsGeneric = AuthMainProps & InjectedIntlProps;

const Panel = HOCPanel();

const AuthenticationMainIntl = ({
  agreeCompetitionValue,
  allFilled,
  banner,
  competitionExists,
  competitionId,
  competitionName,
  email,
  errors,
  handleBiometricCancel,
  handleBiometricSignIn,
  handleBlur,
  handleChange,
  handleCleanCaptcha,
  handlePasswordKeyUp,

  handleSignUp,
  handleUserLogin,
  hasLoggedInBefore,
  inquiryId,
  intl,
  isCapsLockOn,
  isLoading,
  isLoggedIn,
  password,
  previousLocation,
}: AuthMainPropsGeneric) => (
  <section className="auth">
    {competitionExists && (
      <Container modifiers={['banner']}>
        <img className="img__banner" src={banner} />
      </Container>
    )}
    <Container>
      {isLoading ? (
        <div className="loader">
          <Loader active={true} inline="centered" size="massive" />
        </div>
      ) : isLoggedIn && !hasLoggedInBefore ? (
        <Redirect from="/sign-in" to={previousLocation.state != null ? previousLocation.state.from : '/'} />
      ) : inquiryId ? (
        <Panel
          title={intl.formatMessage({
            id: 'authenticationMain.biometric.authentication',
            defaultMessage: localeData.en['authenticationMain.biometric.authentication'],
          })}
        >
          <BiometricSignIn
            initialInquiryId={inquiryId}
            handleBiometricCancel={handleBiometricCancel}
            handleBiometricSignIn={handleBiometricSignIn}
          />
        </Panel>
      ) : (
        <Panel title={intl.formatMessage({ id: 'authenticationMain.signIn', defaultMessage: localeData.en['authenticationMain.signIn'] })}>
          <AuthenticationContent
            agreeCompetitionValue={agreeCompetitionValue}
            allFilled={allFilled}
            competition={competitionExists}
            competitionId={competitionId}
            competitionName={competitionName}
            email={email}
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            handleCleanCaptcha={handleCleanCaptcha}
            handlePasswordKeyUp={handlePasswordKeyUp}
            handleSignUp={handleSignUp}
            handleUserLogin={handleUserLogin}
            isCapsLockOn={isCapsLockOn}
            password={password}
          />
        </Panel>
      )}
    </Container>
  </section>
);

export const AuthenticationMain = injectIntl(AuthenticationMainIntl);
